<script>
export const allowedStyling = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
export const allowedTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div'];
export const defaultTag = 'h1';

export default {
  name: 'EHeading',
  props: {
    as: {
      type: String,
      default: null,
      validator(value) {
        return allowedTags.includes(value);
      },
    },
    styledAs: {
      type: String,
      default: null,
      validator(value) {
        return allowedStyling.includes(value);
      },
    },
  },
  computed: {
    tag() {
      if (!this.$options.props.as.validator(this.as)) {
        return defaultTag;
      }

      return this.as;
    },
    style() {
      if (!this.$options.props.styledAs.validator(this.styledAs)) {
        return this.tag === 'div' ? defaultTag : this.tag;
      }
      return this.styledAs;
    },
  },
  render(create) {
    const options = {
      class: `heading heading--${this.style}`,
      on: this.$listeners,
      attrs: this.$attrs,
    };
    return create(this.tag, options, this.$slots.default);
  },
};
</script>

<style lang="scss" scoped>
.heading {
  display: block;
  color: $color-text-primary;
  margin: 0;
  line-height: $line-height-s;

  &--h1 {
    font-size: $font-3l;

    @include tablet {
      font-size: $font-4l;
    }
  }

  &--h2 {
    font-size: $font-2l;

    @include tablet {
      font-size: $font-3l;
    }
  }

  &--h3 {
    font-size: $font-1l;

    @include tablet {
      font-size: $font-2l;
    }
  }

  &--h4 {
    font-size: $font-l;

    @include tablet {
      font-size: $font-1l;
    }
  }

  &--h5 {
    font-size: $font-l;

    @include tablet {
      font-size: $font-l;
    }
  }

  &--h6 {
    font-size: $font-m;

    @include tablet {
      font-size: $font-m;
    }
  }
}
</style>

<docs>
Default:

```js
<EHeading>A headline</EHeading>
```

When no props are provided, the `EHeading` component will render as
`h1` tag with the style of a `h1`.

With custom tag:

```js
<EHeading as="h2">A headline</EHeading>
```

When not assigning the `styledAs` property, the style of the tag (`as` prop)
will be used instead. In this case, the tag is `h2` but styled as `h1`:

```js
<EHeading as="h2" styledAs="h1">A headline</EHeading>
```
</docs>
